import React from 'react';

const Role = ({ ROLE }) => {
  return (
    <div className="row">
      <div className="col-md-12 left-header">{ROLE}</div>
    </div>
  );
};

export default Role;
